import styled from 'styled-components';

import { VisitFormController } from '../../visitForm.types';

import { ProceduresTable } from './ProceduresTable';
import { ProceduresTableSelector } from './ProceduresTableSelector';

const StyledProceduresFormTab = styled.div`
   height: 100%;
   overflow: hidden;
`;
StyledProceduresFormTab.displayName = 'StyledProceduresFormTab';

type ProceduresFormTabProps = Pick<VisitFormController, 'register'> & {
   readonly dictionaryValidOn: Date;
};

export const ProceduresFormTab = (props: ProceduresFormTabProps): JSX.Element => {
   return (
      <StyledProceduresFormTab>
         <ProceduresTable
            register={props.register}
            selector={<ProceduresTableSelector register={props.register} dictionaryValidOn={props.dictionaryValidOn} />}
         />
      </StyledProceduresFormTab>
   );
};
